module.exports = __webpack_public_path__ + "static/note-dismiss-dont-b09dda80f84d60861b74f42924bb4ca4.png";